<template>
  <div class="loading" data-cy="loading" :style="iconSize">
    <fa icon="spinner" type="fas" class="fa-spin"></fa>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Loading",

  props: {
    width: {
      type: String,
      default: "30px",
      required: false
    },

    height: {
      type: String,
      default: "30px",
      required: false
    }
  },

  computed: {
    iconSize(): string {
      return `width: ${this.width}; height: ${this.height};`;
    }
  }
});
</script>

<style lang="scss" scoped>
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
.fa-spin {
  animation: spinner 2s linear infinite;
}
</style>
